import { Player } from "@/types/Player";

type PlayerInfoViewProps = {
  player: Player;
};

const PlayerInfoView = ({ player }: PlayerInfoViewProps) => {
  const info = [
    { label: "FUT Name", value: player.full_name },
    { label: "Nation", value: player.nation },
    { label: "League", value: player.league },
    { label: "Club", value: player.club },
    { label: "Version", value: player.version },
  ];

  return (
    <div className="p-2 rounded-lg flex flex-col w-fit whitespace-nowrap bg-gray-900 shadow z-11 text-tiny desktop:text-sm">
      {info.map(({ label, value }) => (
        <div key={label} className="flex flex-row">
          <div className="text-left mx-1 font-bold">{label}:</div>
          <div>{value}</div>
        </div>
      ))}
    </div>
  );
};

export { PlayerInfoView };
